import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

function fmtErr(e) {
  // FastAPI usually returns { detail: "..." } or an array of pydantic errors.
  const d = e?.response?.data?.detail;
  if (d) {
    if (typeof d === 'string') return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
    return d.msg || String(d);
  }
  // No response body = usually CORS or network. Give a real hint.
  if (e?.message?.includes('Network') || e?.code === 'ERR_NETWORK') {
    return "Can't reach the backend. If you're the site owner: check CORS_ORIGINS on Railway.";
  }
  return e?.message || 'Something went wrong. Open browser console for details.';
}

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await login(email, password);
      nav('/admin');
    } catch (e2) {
      console.error('Login failed', e2);
      setErr(fmtErr(e2));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-paper grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="mono text-[11px] uppercase tracking-[0.3em] text-ink/60 hover:text-orchid">← Back</Link>
        <h1 className="serif text-5xl md:text-6xl text-ink mt-6 mb-2">The <span className="italic text-grape">back office</span>.</h1>
        <p className="mono text-sm text-ink/60 mb-10">Admin only. If you&rsquo;re here by accident, the door is that way.</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="mono text-[10px] uppercase tracking-[0.3em] text-orchid block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-ink/40 focus:border-orchid outline-none mono text-base py-2"
              required
            />
          </div>
          <div>
            <label className="mono text-[10px] uppercase tracking-[0.3em] text-orchid block mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-ink/40 focus:border-orchid outline-none mono text-base py-2"
              required
            />
          </div>
          {err && <div data-testid="login-error" className="mono text-xs text-red-800/80">{err}</div>}
          <button
            data-testid="login-submit"
            disabled={busy}
            className="w-full bg-void text-paper py-4 mono uppercase tracking-[0.25em] text-xs hover:bg-orchid transition-colors disabled:opacity-60"
          >
            {busy ? 'Opening the door…' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  );
}
